import { render, staticRenderFns } from "./shopSuss.vue?vue&type=template&id=70f98d7e&scoped=true"
import script from "./shopSuss.vue?vue&type=script&lang=js"
export * from "./shopSuss.vue?vue&type=script&lang=js"
import style0 from "./shopSuss.vue?vue&type=style&index=0&id=70f98d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f98d7e",
  null
  
)

export default component.exports